import { cn } from "@app/lib/utils";

export const loadingSize = {
  xs: 14,
  sm: 16,
  md: 24,
  lg: 28,
  xl: 32,
} as const;

export type LoadingSize = keyof typeof loadingSize | number;

export function getLoadingSize(size: LoadingSize = "md") {
  return typeof size === "number" ? size : loadingSize[size];
}

export function Spinner({
  className,
  size = "md",
}: {
  className?: string;
  size?: LoadingSize;
}) {
  const actualSize = getLoadingSize(size);

  return (
    <svg
      className={cn(
        "animate-spin text-primary motion-reduce:animate-none",
        className,
      )}
      style={{ height: actualSize, width: actualSize }}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
